import { ApiGroupModel } from './group-sidebar.component';

export class GroupSidebarGroupsController {
    static $inject = ['AuthService', 'graph-group-factory'];

    public filterType!: 'joined' | 'own' | 'top';
    public flatlist!: boolean;
    public addButton!: boolean;

    public groups: ApiGroupModel[] = [];
    public filter = '';
    public isLoading = false;

    public onFilterChange = (filter: string) => {
        this.filter = filter;
    };

    public get isEmpty() {
        return this.groups.length === 0;
    }

    constructor(private AuthService: any, private groupFactory: any) {}

    $onInit() {
        if (this.AuthService.getUser()) {
            this.queryGroups();
        }
    }

    protected getApiEndpoint() {
        switch (this.filterType) {
            case 'joined':
                return this.groupFactory.joined();
            case 'own':
                return this.groupFactory.own();
            case 'top':
                return this.groupFactory.top();
        }
    }

    queryGroups() {
        this.isLoading = true;

        this.getApiEndpoint().then((response: ng.IHttpResponse<ApiGroupModel[]>) => {
            this.groups = [...this.groups, ...response.data];
            this.isLoading = false;
        });
    }
}

angular.module('tradersyard').component('tyGroupSidebarGroups', {
    template: `
    <div class="group_sidebar_filter">
      <ty-filter value="$ctrl.filter" on-change="$ctrl.onFilterChange" placeholder="Filter groups"/>
    </div>
    <div ng-if="$ctrl.isLoading" class="group_sidebar_message">
        <ty-loading-spinner/>
    </div>
    <ty-group-sidebar-list
            flatlist="$ctrl.flatlist"
            add-button="$ctrl.addButton"
            ng-if="!$ctrl.isLoading" filter="$ctrl.filter" groups="$ctrl.groups"
    />
    <div ng-if="!$ctrl.isLoading && $ctrl.isEmpty" class="group_sidebar_message">
        No groups found
    </div>
    `,
    controller: GroupSidebarGroupsController,
    bindings: {
        filterType: '<',
        flatlist: '<',
        addButton: '<',
    },
});
